import React from 'react';
import {
  EditPageContainer,
  Page,
  withServerErrors,
  withResolver,
  withDebug,
} from 'components/common';
import {
  FormGroup,
  SaveButton,
  BackButton,
  required,
} from 'components/common/Forms';
import { compose, withState} from 'recompose';
import { LocalForm, Control, Errors, actions } from 'react-redux-form';

const passwordsMatch = ({ password, confirmPassword }) =>
  password === confirmPassword;

const HelpText = props => (
  <span className="form-text small text-danger" {...props} />
);

const changeThenValidate = dispatch => (model, value) => {
  dispatch(actions.change(model, value));
  dispatch(actions.validate(model));
};

export const UserEdit = ({
  mode,
  role,
  options,
  item,
  form,
  onBack,
  setDispatch,
  dispatch,
  onSubmit,
  onUpdate,
  onChange,
  roles,
  setRoles,
  rolesUrl,
  renderServerError,
  readOnly,
  selectedRole,
  setSelectedRole,
  resellers,
}) => (
  <Page title={`${mode} User`}>
    <LocalForm
      initialState={item}
      onSubmit={onSubmit}
      getDispatch={setDispatch}
      onUpdate={onUpdate}
      onChange={onChange}
      validators={{ '': { passwordsMatch } }}
    >
      {/* 
        Hidden password field to trick the credential autofill system, 
        means the users own password is autofilled here rather than in 
        the New User's password field 
      */}
      <input type="password" style={{ display: 'none' }} />
      <FormGroup label="Username *" model=".username">
        <Control.text
          updateOn="blur"
          model=".username"
          required
          disabled={!!item.id}
        />
      </FormGroup>
      {renderServerError('username')}
      <FormGroup label="First Name *" model=".first_name">
        <Control.text
          updateOn="blur"
          model=".first_name"
          required
          disabled={readOnly}
        />
      </FormGroup>
      <FormGroup label="Last Name *" model=".last_name">
        <Control.text updateOn="blur" model=".last_name" disabled={readOnly} />
      </FormGroup>
      <FormGroup label="Email *" model=".email">
        <Control.text
          updateOn="blur"
          type="email"
          model=".email"
          required
          changeAction={changeThenValidate(dispatch)}
        />
        <Errors model=".email" component={HelpText} />
      </FormGroup>
      <FormGroup
        label={'Password' + (mode !== 'New' ? '' : ' *')}
        model=".password"
        hidden={readOnly}
      >
        <Control.text
          updateOn="blur"
          type="password"
          model=".password"
          validators={{ required: v => mode !== 'New' || v }}
          changeAction={changeThenValidate(dispatch)}
          autocomplete="new-password"
        />
        <Errors model=".password" component={HelpText} />
      </FormGroup>
      <FormGroup
        label={'Confirm Password' + (mode !== 'New' ? '' : ' *')}
        model=".confirmPassword"
        hidden={readOnly}
      >
        <Control.text
          updateOn="blur"
          type="password"
          model=".confirmPassword"
          validators={{ required: v => mode !== 'New' || v }}
          autocomplete="new-password"
        />
        <Errors
          model="."
          messages={{ passwordsMatch: 'Passwords do not match' }}
          component={HelpText}
        />
      </FormGroup>
     {roles &&
        <FormGroup label="Role *" model=".role">
          <Control.select
            model=".role"
            validators={{ required }}
            disabled={readOnly}
            onChange={(e => setSelectedRole(e.target.value))}
          >
            <option value="" />
            {roles.map(ur => (
              <option value={ur.id} key={ur.id} >
                {ur.title}
              </option>
            ))}
          </Control.select>
        </FormGroup>
     }
     {(selectedRole === '100' || item.role === 100) &&
        <FormGroup label="Reseller/White Label Partner *">
          <Control.select
            model=".white_label_id"
            validators={{ required }}
            disabled={readOnly}
            required
          >
            <option value="" />
            {resellers.map(ur => (
              <option value={ur.id} key={ur.id} >
                {ur.name}
              </option>
            ))}
          </Control.select>
        </FormGroup>
     }
      <FormGroup label="Active" check disabled={readOnly}>
        <Control.checkbox model=".is_active" />
      </FormGroup>
      {renderServerError('is_active')}
      <FormGroup label="Reset Password on Next Login" check disabled={readOnly}>
        <Control.checkbox model=".reset_password" defaultChecked />
      </FormGroup>
      {renderServerError('reset_password')}
      <SaveButton className="float-right" form={form} hidden={readOnly} />
      <BackButton className="float-right mr-2" onClick={onBack} />
    </LocalForm>
  </Page>
);

export default compose(
  withState('selectedRole', 'setSelectedRole', '')
) (UserEdit);


// WEBPACK FOOTER //
// ./src/pages/Users/UnComposedEdit.jsx